import React from 'react';

const TableHead = () => {
  const className = 'd-none d-md-table-cell';

  return (
    <thead>
      <tr className="py-5">
        <th scope="col">Name</th>
        <th scope="col" className={className}>
          Plays
        </th>
        <th scope="col" className={className}>
          Copy
        </th>
        <th scope="col" className={className}>
          Status
        </th>
        <th scope="col" className={className}>
          Renew
        </th>
        <th scope="col">Remove</th>
      </tr>
    </thead>
  );
};

export default TableHead;
